import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "night-actions-panel"
}
const _hoisted_2 = { class: "panel-header" }
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 1,
  class: "night-wait-panel"
}
const _hoisted_6 = {
  key: 2,
  class: "night-wait-panel"
}

import { computed } from 'vue';
import { useGameStore } from '@/stores/gameStore';
import PlayerGrid from './PlayerGrid.vue';
import PlayerCard from './PlayerCard.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'NightActionsPanel',
  props: {
    selectedPlayerName: {}
  },
  emits: ['playerSelect'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const gameStore = useGameStore();
const isAlive = computed(() => gameStore.myPlayer?.is_alive ?? false);


const ACTION_CONFIGS: Record<string, { title: string; description: string; buttonText: string; actionType: string; }> = {
    mafia: {
        title: 'Голосование Мафии',
        description: 'Выберите жертву, которую хотите устранить этой ночью. Ваша команда должна прийти к единому мнению.',
        buttonText: 'Убить',
        actionType: 'mafia_kill'
    },
    doctor: {
        title: 'Выбор Доктора',
        description: 'Выберите игрока, которого хотите спасти от смерти этой ночью. Вы можете выбрать себя.',
        buttonText: 'Вылечить',
        actionType: 'doctor_heal'
    },
    comissar: {
        title: 'Проверка Комиссара',
        description: 'Выберите игрока, чтобы узнать, принадлежит ли он к Мафии.',
        buttonText: 'Проверить',
        actionType: 'commissar_check'
    },
    whore: {
        title: 'Визит Ночной Бабочки',
        description: 'Выберите игрока, чтобы лишить его возможности действовать и голосовать этой ночью.',
        buttonText: 'Блокировать',
        actionType: 'whore_block'
    }
};

const actionConfig = computed(() => ACTION_CONFIGS[gameStore.myRole || '']);
const isMyRoleActive = computed(() => !!gameStore.myRole && gameStore.myRole !== 'citizen');

const eligibleTargets = computed(() => {
    if (!gameStore.room) return [];
    const alivePlayers = gameStore.room.players.filter(p => p.is_alive);

    if (gameStore.myRole === 'doctor') {
        return alivePlayers;
    }

    return alivePlayers.filter(p =>
        p.name !== gameStore.myPlayer?.name &&
        !gameStore.teammates.includes(p.name)
    );
});

const buttonText = computed(() => {
    if (gameStore.myPlayerHasActed) return 'Ожидаем других...';
    if (props.selectedPlayerName) return `${actionConfig.value.buttonText} "${props.selectedPlayerName}"`;
    return 'Выберите цель';
});

const submitAction = () => {
    if (!props.selectedPlayerName) return;
    gameStore.performAction(actionConfig.value.actionType, { target_name: props.selectedPlayerName });
    gameStore.confirmTeamTarget(props.selectedPlayerName);
};


return (_ctx: any,_cache: any) => {
  return (isMyRoleActive.value && isAlive.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", null, _toDisplayString(actionConfig.value.title), 1),
          _createElementVNode("p", null, _toDisplayString(actionConfig.value.description), 1)
        ]),
        _createVNode(PlayerGrid, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eligibleTargets.value, (player) => {
              return (_openBlock(), _createBlock(PlayerCard, {
                key: player.name,
                player: player,
                "is-selectable": !_unref(gameStore).myPlayerHasActed,
                "is-selected": player.name === _ctx.selectedPlayerName,
                onClick: ($event: any) => (!_unref(gameStore).myPlayerHasActed && _ctx.$emit('playerSelect', player.name))
              }, null, 8, ["player", "is-selectable", "is-selected", "onClick"]))
            }), 128))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: submitAction,
            disabled: !_ctx.selectedPlayerName || _unref(gameStore).myPlayerHasActed,
            class: "btn"
          }, _toDisplayString(buttonText.value), 9, _hoisted_4)
        ])
      ]))
    : (!isAlive.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[0] || (_cache[0] = [
          _createElementVNode("h3", null, "Вы мертвы", -1),
          _createElementVNode("p", null, "Ожидайте наступления утра.", -1)
        ])))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[1] || (_cache[1] = [
          _createElementVNode("h3", null, "Ночь в городе...", -1),
          _createElementVNode("p", null, "Вы мирно спите, пока другие вершат судьбы. Ожидайте наступления утра.", -1)
        ])))
}
}

})